<template>
    <div id="News" class="col-lg-6">
            
        <div
      class="container"
      v-for="contactDetail of contactDetails"
      v-bind:key="contactDetail._id"
    >
      <div class="section" v-if="contactDetail._id">
          <div class="header-container">
        <h2>{{ contactDetail.title }}</h2>
          </div>
        <div :inner-html.prop="contactDetail.description">
         
        </div>
      </div>
    </div>
    </div>
</template>


<script>
import ContentService from "@/services/ContentService.js";

export default {
  data() {
    return {
      contactDetails: [],
    };
  },
  created() {
     ContentService.getCategorizedContent(this.$application, this.$t("languageCode"), this.$t("contactUsSlug"))
      .then((res) => (this.contactDetails = res.data))
      .catch((error) => console.log("There was an error:" + error));
  },

  mounted() {},

  filters: {
    truncate: function(text, stop, clamp) {
      return text.slice(0, stop) + (stop < text.length ? clamp || "..." : "");
    },
  },
};
</script>

<style></style>
